import { Button, ButtonBase, CircularProgress } from "@mui/material";
import { Checkbox, Input, Select, Tabs } from "antd";
import ImageInput from "../LoanProduct/ImageInput";
import { useState } from "react";
import CropPopup from "../LoanProduct/CropPopUp";
import { useRef } from "react";
import ContactCard from "./ContactCard";
import {
  Controller,
  FormProvider,
  useFieldArray,
  useForm,
} from "react-hook-form";
import { useEffect } from "react";
import { useContext } from "react";
import { AuthenticationContext } from "../../App";
import dayjs from "dayjs";
import { useQuery } from "react-query";
import countryCode from "../../config/countryCode.json";
import axios from "../../axios/axios";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
const IMAGE_BASE_URL = "https://api.ohhto.com";
async function dataURItoBlob(url) {
  return await (await fetch(url)).blob();
}
const rat_items = [
  {
    key: 0,
    label: `In-House`,
  },
  {
    key: 1,
    label: `Flooring`,
  },
];
const Profile = () => {
  const { authData } = useContext(AuthenticationContext);
  const settings = useSelector((state) => state.settings);
  // console.log("authData", authData?.is_primary);


  const [pin, setPin] = useState("••••");
  const [seconds, setSeconds] = useState(0);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    if (seconds > 0) {
      const timer = setTimeout(() => setSeconds(seconds - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      setDisabled(false);
      setPin("••••");
    }
  }, [seconds]);

  const formatTime = () => {
    const min = String(Math.floor(seconds / 60)).padStart(2, "0");
    const sec = String(seconds % 60).padStart(2, "0");
    return `${min}:${sec}`;
  };

  //GeneratePin
  const handleResendPin = async () => {
    const newPin = Math.floor(1000 + Math.random() * 9000).toString();
    setPin(newPin);
    setSeconds(180);
    setDisabled(true);
    try {
      const response = await axios.post('generate-pin', {
        security_pin: newPin,
      });
      console.log("PIN stored:", response.data);
    } catch (error) {
      console.error("Error storing PIN:", error);
    }
  };

  const methods = useForm({
    defaultValues: {
      name: "",
      email: "",
      uenNumber: "",
      faxNumber: "",
      phoneNumber: "",
      featured: "",
      addressLine1: "",
      addressLine2: "",
      countryCode: "",
      country: "",
      postalCode: "",
      ltv: "",
      approvalTime: "",
      floor_approvalTime: "",
      floor_ltv: "",
      contacts: [
        {
          name: "",
          designation: "",
          countryCode: "",
          phoneNumber: "",
          email: "",
          smsNotification: false,
          emailNotification: false,
          isPrimary: true,
        },
      ],
    },
  });
  const {
    control,
    setValue,
    getValues,
    handleSubmit,
    watch,
    formState: { errors },
  } = methods;
  const [imgErr, setImgErr] = useState(false);
  const [subBtnLoad, setsubBtnLoad] = useState(false);
  const imgPosRef = useRef(null);
  const pwdPosRef = useRef(null);
  const [productIcon, setProductIcon] = useState(null);
  const [showCrop, setShowCrop] = useState(false);
  const [croppedImage, setCroppedImage] = useState(false);
  const [image, setImage] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [resPassword, setresPassword] = useState(false);
  const [pwdData, setpwdData] = useState({
    password: "",
    cnfirm_pwd: "",
    pwdError: false,
    cpwdError: false,
  });
  const [createData, setCreateData] = useState({});
  const [ratingsTab, setratingsTab] = useState(0);
  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setShowCrop(true);
      setImage(URL.createObjectURL(event.target.files[0]));
    }
  };
  const submitFormData = async (data) => {
    if (!imgErr && !pwdData.pwdError && !pwdData.cpwdError) {
      setsubBtnLoad(true);
      const postData = {
        ...data,
        icon: productIcon,
        ltv: authData.ltv,
        approvalTime: authData.approvalTime,
      };
      try {
        const resp = await axios.put("/profile/update", postData, {
          headers: {
            Authorization: `Bearer ${authData?.token}`,
          },
        });
        setsubBtnLoad(false);
        if (resp?.data?.resp_code === 200) {
          setEditMode(false);
          setresPassword(false);
          setpwdData((prev) => ({
            ...prev,
            pwdError: false,
            password: "",
            cnfirm_pwd: "",
            cpwdError: false,
          }));
          toast.success(resp.data?.message);
          window.scrollTo({ top: 0 });
        }
      } catch (err) {
        //console.log("ERROR", err.response.data?.errors);
        const temp = Object.values(err.response.data?.errors);
        toast.error(
          temp?.length > 0 ? temp[0] : "Agent profile not updated..!"
        );
      }
    }
  };
  const clickSubmitData = (act) => {
    let err = 0;
    setImgErr(false);
    setpwdData((prev) => ({
      ...prev,
      cpwdError: false,
      pwdError: false,
    }));
    if (!croppedImage && productIcon === null) {
      setImgErr(true);
      if (imgPosRef.current) {
        imgPosRef.current.scrollIntoView({
          block: "start",
          behavior: "smooth",
        });
      }
      err++;
    }
    if (resPassword) {
      if (pwdData.password === "") {
        setpwdData((prev) => ({
          ...prev,
          pwdError: true,
        }));
        if (pwdPosRef.current) {
          pwdPosRef.current.scrollIntoView({
            block: "start",
            behavior: "smooth",
          });
        }
        err++;
      }
      if (pwdData.cnfirm_pwd === "") {
        setpwdData((prev) => ({
          ...prev,
          cpwdError: true,
        }));
        if (pwdPosRef.current) {
          pwdPosRef.current.scrollIntoView({
            block: "start",
            behavior: "smooth",
          });
        }
        err++;
      }
    }
    if (err === 0 && act === "top_edit") {
      handleSubmit(submitFormData)();
    }
  };
  useEffect(() => {
    if (authData) {
      //console.log(authData);
      setValue("name", authData.name);
      setValue("featured", authData.featured);
      setValue("phoneNumber", authData.phoneNumber);
      setValue("postalCode", authData.postalCode);
      setValue("uenNumber", authData.uenNumber);
      setValue("faxNumber", authData.faxNumber);
      setValue("email", authData.email);
      setValue("countryCode", authData.countryCode);
      setValue("country", authData.country);
      setValue("addressLine1", authData.addressLine1);
      setValue("addressLine2", authData.addressLine2);
      setValue("ltv", authData?.ltvinfo?.name);
      setValue("approvalTime", authData?.approvaltimeinfo?.name);
      setValue("floor_approvalTime", authData?.floor_approvalTime);
      setValue("floor_ltv", authData?.floor_ltv);
      setProductIcon(authData?.icon);
      authData?.contacts.forEach((item, idx) => {
        setValue(`contacts.${idx}.name`, item.name);
        setValue(`contacts.${idx}.designation`, item.designation);
        setValue(`contacts.${idx}.countryCode`, item.countryCode);
        setValue(`contacts.${idx}.phoneNumber`, item.phoneNumber);
        setValue(`contacts.${idx}.email`, item.email);
        setValue(
          `contacts.${idx}.smsNotification`,
          item.smsNotification === 0 ? false : true
        );
        setValue(
          `contacts.${idx}.emailNotification`,
          item.emailNotification === 0 ? false : true
        );
        setValue(
          `contacts.${idx}.isPrimary`,
          item.isPrimary === 0 ? false : true
        );
      });
    }
  }, []);


  return (
    <div className="flex_adjust min-h-screen">
      <div className="flex justify-between items-center p-[16px_24px] border-b border-[#e3e3e3] bg-white" >
        <h2 className="text-[20px] font-[700] text-[#1a202c]">Profile</h2>
      </div>
      <Tabs defaultActiveKey="1" className="w-full" tabBarStyle={{ display: 'flex', justifyContent: 'center', margin: '0px auto' }}>
        <Tabs.TabPane tab="Profile" key="1">
          <div>
            {showCrop ? (
              <CropPopup
                image={image}
                setActive={setShowCrop}
                setImage={setCroppedImage}
              />
            ) : null}
          </div>
          {editMode ? (
            <div className="flex items-center gap-[10px]">
              <Button
                type="button"
                className="can_btn"
                onClick={() => setEditMode(false)}
              >
                Cancel
              </Button>
              <Button
                type="button"
                className="sav_btn"
                onClick={() => clickSubmitData("top_edit")}
              >
                {subBtnLoad && (
                  <CircularProgress
                    size={20}
                    style={{ color: "white" }}
                    className="mr-[13px]"
                  />
                )}
                Save
              </Button>
            </div>
          ) : (
            <Button
              type="button"
              className="sav_btn"
              style={{ float: "right" }}
              onClick={() => setEditMode(true)}
            >
              Edit
            </Button>
          )}
          <FormProvider {...methods}>
            <div className="p-[32px_36px]">
              {editMode ? (
                <form
                  className="profile_form w-[600px] max-w-full"
                  onSubmit={handleSubmit(submitFormData)}
                >
                  <div className="mb-[30px]">
                    <label className="block mb-[4px] text-[13px] text-[#798188]">
                      Full Name
                    </label>
                    <Controller
                      control={control}
                      name="name"
                      rules={{
                        required: true,
                      }}
                      render={({ field, fieldState }) => {
                        return (
                          <Input
                            {...field}
                            status={fieldState.error ? "error" : null}
                            placeholder="Enter Full Name"
                          />
                        );
                      }}
                    />
                  </div>
                  <div className="mb-[30px]">
                    <label className="block mb-[4px] text-[13px] text-[#798188]">
                      {authData?.is_primary == 1 ? "Agent Email" : "Email"}
                    </label>
                    <Controller
                      control={control}
                      name="email"
                      rules={{
                        required: true,
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          message: "*Invalid Email",
                        },
                      }}
                      render={({ field, fieldState }) => {
                        return (
                          <Input
                            {...field}
                            status={fieldState.error ? "error" : null}
                            placeholder="Enter Email address"
                          />
                        );
                      }}
                    />
                  </div>
                  <div className="flex items-center gap-[0_10px] max-[600px]:flex-wrap">
                    <div className="mb-[30px] w-[100px] max-[600px]:w-full">
                      <label className="block mb-[4px] text-[13px] text-[#798188]">
                        Country Code*
                      </label>
                      <Controller
                        control={control}
                        name="countryCode"
                        rules={{
                          required: true,
                        }}
                        render={({ field, fieldState }) => {
                          return (
                            <Select
                              {...field}
                              showSearch
                              status={fieldState.error ? "error" : null}
                              suffixIcon={
                                <img
                                  src="/images/select_ar.svg"
                                  alt="arrow"
                                  className="mr-[2px]"
                                />
                              }
                              className="w-full"
                            >
                              {countryCode.map((item, idx) => {
                                return (
                                  <Select.Option key={idx} value={item.dial_code}>
                                    {item.dial_code}
                                  </Select.Option>
                                );
                              })}
                            </Select>
                          );
                        }}
                      />
                    </div>
                    <div className="mb-[30px] flex-[1] max-[600px]:flex-[unset] max-[600px]:w-full">
                      <label className="block mb-[4px] text-[13px] text-[#798188]">
                        Contact Number
                      </label>
                      <Controller
                        control={control}
                        name="phoneNumber"
                        rules={{
                          required: true,
                        }}
                        render={({ field, fieldState }) => {
                          return (
                            <Input
                              {...field}
                              maxLength={8}
                              status={fieldState.error ? "error" : null}
                              placeholder="Contact Number"
                            />
                          );
                        }}
                      />
                    </div>
                    {authData?.is_primary == 1 && (
                      <div className="mb-[30px] w-[184px] max-[600px]:w-full">
                        <label className="block mb-[4px] text-[13px] text-[#798188]">
                          Fax Number
                        </label>
                        <Controller
                          control={control}
                          name="faxNumber"
                          render={({ field }) => {
                            return <Input {...field} placeholder="Fax Number" />;
                          }}
                        />
                      </div>
                    )}
                  </div>

                  {authData?.is_primary == 1 && (
                    <>
                      <h4 className="text-[#1a202c] text-[14px] font-[600] mb-[20px]">
                        Agent Details
                      </h4>
                      <div>
                        <div className="mb-[30px]">
                          <label
                            className="block mb-[4px] text-[13px] text-[#798188]"
                            ref={imgPosRef}
                          >
                            Agent's Logo
                          </label>
                          <ImageInput
                            error={imgErr}
                            image={
                              croppedImage
                                ? croppedImage
                                : productIcon && productIcon !== ""
                                  ? `${IMAGE_BASE_URL}/${productIcon}`
                                  : ""
                            }
                            setImage={onImageChange}
                          />
                        </div>
                      </div>
                      <div className="flex items-center gap-[0_10px] max-[600px]:flex-wrap">
                        <div className="mb-[30px] flex-[1] max-[600px]:flex-[unset] max-[600px]:w-full">
                          <label className="block mb-[4px] text-[13px] text-[#798188]">
                            Agent Company Name
                          </label>
                          <Controller
                            control={control}
                            name="name"
                            rules={{
                              required: true,
                            }}
                            render={({ field, fieldState }) => {
                              return (
                                <Input
                                  {...field}
                                  status={fieldState.error ? "error" : null}
                                  placeholder="Enter Company Name"
                                  disabled={editMode}
                                />
                              );
                            }}
                          />
                        </div>
                        <div className="mb-[30px] w-[184px] max-[600px]:w-full">
                          <label className="block mb-[4px] text-[13px] text-[#798188]">
                            UEN Number
                          </label>
                          <Controller
                            control={control}
                            name="uenNumber"
                            rules={{
                              required: true,
                            }}
                            render={({ field, fieldState }) => {
                              return (
                                <Input
                                  {...field}
                                  status={fieldState.error ? "error" : null}
                                  placeholder="UEN Number"
                                  disabled={editMode}
                                />
                              );
                            }}
                          />
                        </div>
                      </div>
                      <div className="mb-[30px]">
                        <label className="block mb-[4px] text-[13px] text-[#798188]">
                          Address
                        </label>
                        <Controller
                          control={control}
                          name="addressLine1"
                          rules={{
                            required: true,
                          }}
                          render={({ field, fieldState }) => {
                            return (
                              <Input
                                {...field}
                                status={fieldState.error ? "error" : null}
                                placeholder="Address 1 ( Floor, Unit No., Street Name)"
                              />
                            );
                          }}
                        />
                      </div>
                      <div className="mb-[30px]">
                        <Controller
                          control={control}
                          name="addressLine2"
                          rules={{
                            required: true,
                          }}
                          render={({ field, fieldState }) => {
                            return (
                              <Input
                                {...field}
                                status={fieldState.error ? "error" : null}
                                placeholder="Address 2 (Building name, other info)"
                              />
                            );
                          }}
                        />
                      </div>
                      <div className="flex items-center gap-[0_10px] max-[600px]:flex-wrap">
                        <div className="mb-[30px] flex-[1] max-[600px]:flex-[unset] max-[600px]:w-full">
                          <Controller
                            control={control}
                            name="postalCode"
                            rules={{
                              required: true,
                            }}
                            render={({ field, fieldState }) => {
                              return (
                                <Input
                                  {...field}
                                  status={fieldState.error ? "error" : null}
                                  placeholder="Postal Code"
                                />
                              );
                            }}
                          />
                        </div>
                        <div className="mb-[30px] flex-[1] max-[600px]:flex-[unset] max-[600px]:w-full">
                          <Controller
                            control={control}
                            name="country"
                            rules={{
                              required: true,
                            }}
                            render={({ field, fieldState }) => {
                              return (
                                <Select
                                  {...field}
                                  showSearch
                                  status={fieldState.error ? "error" : null}
                                  suffixIcon={
                                    <img
                                      src="/images/select_ar.svg"
                                      alt="arrow"
                                      className="mr-[2px]"
                                    />
                                  }
                                  className="w-full"
                                >
                                  {countryCode.map((item, idx) => {
                                    return (
                                      <Select.Option key={idx} value={item.code}>
                                        {item.name}
                                      </Select.Option>
                                    );
                                  })}
                                </Select>
                              );
                            }}
                          />
                        </div>
                      </div>
                      <h4 className="text-[#1a202c] text-[14px] font-[600] mb-[20px]">
                        Ratings
                      </h4>
                      <Tabs
                        items={rat_items}
                        defaultActiveKey={ratingsTab}
                        onChange={(k) => setratingsTab(k)}
                      />
                      {ratingsTab === 0 ? (
                        <div className="flex items-center gap-[0_10px] max-[600px]:flex-wrap">
                          <div className="mb-[30px] flex-[1] max-[600px]:flex-[unset] max-[600px]:w-full">
                            <label className="block mb-[4px] text-[13px] text-[#798188]">
                              Approval Time
                            </label>
                            <Controller
                              control={control}
                              name="approvalTime"
                              rules={{
                                required: true,
                              }}
                              render={({ field, fieldState }) => {
                                return (
                                  <Select
                                    {...field}
                                    showSearch
                                    status={fieldState.error ? "error" : null}
                                    suffixIcon={
                                      <img
                                        src="/images/select_ar.svg"
                                        alt="arrow"
                                        className="mr-[2px]"
                                      />
                                    }
                                    value={String(getValues("approvalTime"))}
                                    disabled={!editMode}
                                    className="w-full"
                                    disabled={true}

                                  >
                                    {settings?.approvalTimes?.map((item, idx) => {
                                      return (
                                        <Select.Option key={idx} value={item.id}>
                                          {item.name}
                                        </Select.Option>
                                      );
                                    })}
                                  </Select>
                                );
                              }}
                            />
                          </div>
                          <div className="mb-[30px] flex-[1] max-[600px]:flex-[unset] max-[600px]:w-full">
                            <label className="block mb-[4px] text-[13px] text-[#798188]">
                              Loan To Value
                            </label>
                            <Controller
                              control={control}
                              name="ltv"
                              rules={{
                                required: true,
                              }}
                              render={({ field, fieldState }) => {
                                return (
                                  <Select
                                    {...field}
                                    showSearch
                                    status={fieldState.error ? "error" : null}
                                    suffixIcon={
                                      <img
                                        src="/images/select_ar.svg"
                                        alt="arrow"
                                        className="mr-[2px]"
                                      />
                                    }
                                    value={String(getValues("ltv"))}
                                    disabled={!editMode}
                                    className="w-full"
                                    disabled={true}
                                  >
                                    {settings?.ltvs?.map((item, idx) => {
                                      return (
                                        <Select.Option key={idx} value={item.id}>
                                          {item.name}
                                        </Select.Option>
                                      );
                                    })}
                                  </Select>
                                );
                              }}
                            />
                          </div>
                        </div>
                      ) : (
                        <div className="flex items-center gap-[0_10px] max-[600px]:flex-wrap">
                          <div className="mb-[30px] flex-[1] max-[600px]:flex-[unset] max-[600px]:w-full">
                            <label className="block mb-[4px] text-[13px] text-[#798188]">
                              Approval Time
                            </label>
                            <Controller
                              control={control}
                              name="floor_approvalTime"
                              rules={{
                                required: true,
                              }}
                              render={({ field, fieldState }) => {
                                return (
                                  <Select
                                    {...field}
                                    showSearch
                                    status={fieldState.error ? "error" : null}
                                    suffixIcon={
                                      <img
                                        src="/images/select_ar.svg"
                                        alt="arrow"
                                        className="mr-[2px]"
                                      />
                                    }
                                    value={
                                      authData?.floor_approvalTime !== null
                                        ? authData?.floor_approvalTime
                                        : ""
                                    }
                                    disabled={true}
                                    className="w-full"
                                  >
                                    {settings?.approvalTimes?.map((item, idx) => {
                                      return (
                                        <Select.Option key={idx} value={item.id}>
                                          {item.name}
                                        </Select.Option>
                                      );
                                    })}
                                  </Select>
                                );
                              }}
                            />
                          </div>
                          <div className="mb-[30px] flex-[1] max-[600px]:flex-[unset] max-[600px]:w-full">
                            <label className="block mb-[4px] text-[13px] text-[#798188]">
                              Loan To Value
                            </label>
                            <Controller
                              control={control}
                              name="floor_ltv"
                              rules={{
                                required: true,
                              }}
                              render={({ field, fieldState }) => {
                                return (
                                  <Select
                                    {...field}
                                    showSearch
                                    status={fieldState.error ? "error" : null}
                                    suffixIcon={
                                      <img
                                        src="/images/select_ar.svg"
                                        alt="arrow"
                                        className="mr-[2px]"
                                      />
                                    }
                                    value={watch("floor_ltv")}
                                    disabled={true}
                                    className="w-full"
                                  >
                                    {settings?.ltvs?.map((item, idx) => {
                                      return (
                                        <Select.Option key={idx} value={item.id}>
                                          {item.name}
                                        </Select.Option>
                                      );
                                    })}
                                  </Select>
                                );
                              }}
                            />
                          </div>
                        </div>
                      )}
                      <h4 className="text-[#1a202c] text-[14px] font-[600] mb-[20px]">
                        Contacts
                      </h4>
                      <ContactCard />
                      <div className="flex items-center gap-[10px] mt-5">
                        <Button type="button" className="can_btn profile_cn">
                          Cancel
                        </Button>
                        <Button
                          type="sumbit"
                          className="sav_btn"
                          onClick={clickSubmitData}
                        >
                          {subBtnLoad && (
                            <CircularProgress
                              size={20}
                              style={{ color: "white" }}
                              className="mr-[13px]"
                            />
                          )}
                          Save
                        </Button>
                      </div>
                    </>
                  )}
                </form>
              ) : (
                <div className="profile_view w-[600px] max-w-full">
                  <div className="flex items-center gap-[0_10px] max-[600px]:flex-wrap">
                    <div className="mb-[30px] flex-[1] max-[400px]:flex-[unset] max-[400px]:w-full">
                      <label className="block mb-[4px] text-[13px] text-[#798188]">
                        Created On
                      </label>
                      <p className="text-[13px]">
                        {dayjs(authData.created_at).format("DD-MM-YYYY HH:MM")}
                      </p>
                    </div>
                    <div className="mb-[30px] flex-[1] max-[400px]:flex-[unset] max-[400px]:w-full">
                      <label className="block mb-[4px] text-[13px] text-[#798188]">
                        Updated On
                      </label>
                      <p className="text-[13px]">
                        {dayjs(authData.updated_at).format("DD-MM-YYYY HH:MM")}
                      </p>
                    </div>
                  </div>
                  {authData?.is_primary == 1 && (
                    <div className="mb-[30px]">
                      <label className="block mb-[4px] text-[13px] text-[#798188]">
                        Agent Status
                      </label>
                      <p className="text-[13px]">
                        {authData.status == 0
                          ? "Pending"
                          : authData.status == 1
                            ? "Approved"
                            : authData.status == 2
                              ? "Rejected"
                              : authData.status == 3
                                ? "Banned"
                                : ""}
                      </p>
                    </div>
                  )}
                  <div className="mb-[30px]">
                    <label className="block mb-[4px] text-[13px] text-[#798188]">
                      Full Name
                    </label>
                    <p className="text_place">{authData.name}</p>
                  </div>
                  <div className="mb-[30px]">
                    <label className="block mb-[4px] text-[13px] text-[#798188]">
                      {authData?.is_primary == 1 ? "Agent Email" : "Email"}
                    </label>
                    <p className="text_place">{authData.email}</p>
                  </div>
                  <div className="flex items-center gap-[0_10px] max-[600px]:flex-wrap">
                    <div className="mb-[30px] w-[150px] max-[600px]:w-full">
                      <label className="block mb-[4px] text-[13px] text-[#798188]">
                        Country Code*
                      </label>
                      <p className="text_place">{authData.countryCode}</p>
                    </div>
                    <div className="mb-[30px] flex-[1] max-[600px]:flex-[unset] max-[600px]:w-full">
                      <label className="block mb-[4px] text-[13px] text-[#798188]">
                        Contact Number
                      </label>
                      <p className="text_place">{authData.phoneNumber}</p>
                    </div>
                    {authData?.is_primary == 1 && (
                      <div className="mb-[30px] w-[184px] max-[600px]:w-full">
                        <label className="block mb-[4px] text-[13px] text-[#798188]">
                          Fax Number
                        </label>
                        <p className="text_place">{authData.faxNumber}</p>
                      </div>
                    )}
                  </div>
                  <div className="mb-[30px]">
                    <label className="flex justify-between items-center mb-[4px] text-[13px] text-[#798188]">
                      Password
                    </label>
                    <p className="text_place">*********</p>
                  </div>
                  {authData?.is_primary == 1 && (
                    <>
                      <h4 className="text-[#1a202c] text-[14px] font-[600] mb-[20px]">
                        Agent Details
                      </h4>
                      <div className="flex flex-wrap gap-[0_10px]">
                        <div className="mb-[30px] w-[30%] max-[600px]:w-full">
                          <label className="block mb-[4px] text-[13px] text-[#798188]">
                            Agent's Logo
                          </label>
                          <img
                            src={`${IMAGE_BASE_URL}/${productIcon}`}
                            alt="profile"
                            className="w-[30px] h-[30px] object-contain mt-[10px]"
                          />
                        </div>
                      </div>
                      <div className="flex items-center gap-[0_10px] max-[600px]:flex-wrap">
                        <div className="mb-[30px] flex-[1] max-[600px]:flex-[unset] max-[600px]:w-full">
                          <label className="block mb-[4px] text-[13px] text-[#798188]">
                            Agent Company Name
                          </label>
                          <p className="text_place">{authData.name}</p>
                        </div>
                        <div className="mb-[30px] w-[184px] max-[600px]:w-full">
                          <label className="block mb-[4px] text-[13px] text-[#798188]">
                            UEN Number
                          </label>
                          <p className="text_place">{authData.uenNumber}</p>
                        </div>
                      </div>
                      <div className="flex items-center gap-[0_10px] max-[600px]:flex-wrap">
                        <div className="mb-[30px] w-[150px] max-[600px]:w-full">
                          <label className="block mb-[4px] text-[13px] text-[#798188]">
                            Country Code*
                          </label>
                          <p className="text_place">{authData.countryCode}</p>
                        </div>
                        <div className="mb-[30px] flex-[1] max-[600px]:flex-[unset] max-[600px]:w-full">
                          <label className="block mb-[4px] text-[13px] text-[#798188]">
                            Contact Number
                          </label>
                          <p className="text_place">{authData.phoneNumber}</p>
                        </div>
                        <div className="mb-[30px] w-[184px] max-[600px]:w-full">
                          <label className="block mb-[4px] text-[13px] text-[#798188]">
                            Fax Number
                          </label>
                          <p className="text_place">{authData.faxNumber}</p>
                        </div>
                      </div>
                      <div className="mb-[30px]">
                        <label className="block mb-[4px] text-[13px] text-[#798188]">
                          Address Line 1
                        </label>
                        <p className="text_place">{authData.addressLine1}</p>
                      </div>
                      <div className="mb-[30px]">
                        <label className="block mb-[4px] text-[13px] text-[#798188]">
                          Address Line 2
                        </label>
                        <p className="text_place">{authData.addressLine2}</p>
                      </div>
                      <div className="flex items-center gap-[0_10px] max-[600px]:flex-wrap">
                        <div className="mb-[30px] flex-[1] max-[600px]:flex-[unset] max-[600px]:w-full">
                          <label className="block mb-[4px] text-[13px] text-[#798188]">
                            Postal Code
                          </label>
                          <p className="text_place">{authData.postalCode}</p>
                        </div>
                        <div className="mb-[30px] flex-[1] max-[600px]:flex-[unset] max-[600px]:w-full">
                          <label className="block mb-[4px] text-[13px] text-[#798188]">
                            Country
                          </label>
                          <p className="text_place">
                            {/* {authData.country} */}
                            Singapore
                          </p>
                        </div>
                      </div>
                      <h4 className="text-[#1a202c] text-[14px] font-[600] mb-[20px]">
                        Ratings
                      </h4>
                      <Tabs
                        items={rat_items}
                        defaultActiveKey={ratingsTab}
                        onChange={(k) => setratingsTab(k)}
                      />
                      {ratingsTab === 0 ? (
                        <div className="flex flex-wrap gap-[0_10px]">
                          <div className="mb-[30px] w-[32%] max-[600px]:w-full">
                            <label className="block mb-[4px] text-[13px] text-[#798188]">
                              Approval Time
                            </label>
                            <p className="text_place">
                              {String(getValues("approvalTime"))}
                            </p>
                          </div>
                          <div className="mb-[30px] w-[32%] max-[600px]:w-full">
                            <label className="block mb-[4px] text-[13px] text-[#798188]">
                              Loan To Value
                            </label>
                            <p className="text_place">{String(getValues("ltv"))}</p>
                          </div>
                        </div>
                      ) : (
                        <div className="flex flex-wrap gap-[0_10px]">
                          <div className="mb-[30px] w-[32%] max-[600px]:w-full">
                            <label className="block mb-[4px] text-[13px] text-[#798188]">
                              Approval Time
                            </label>
                            <p className="text_place">
                              {authData?.floor_approvaltimeinfo?.name !== undefined
                                ? authData?.floor_approvaltimeinfo?.name
                                : "--"}
                            </p>
                          </div>
                          <div className="mb-[30px] w-[32%] max-[600px]:w-full">
                            <label className="block mb-[4px] text-[13px] text-[#798188]">
                              Loan To Value
                            </label>
                            <p className="text_place">
                              {authData?.floor_ltvinfo?.name !== undefined
                                ? authData?.floor_ltvinfo?.name
                                : "--"}
                            </p>
                          </div>
                        </div>
                      )}
                      <h4 className="text-[#1a202c] text-[14px] font-[600] mb-[20px]">
                        Contacts
                      </h4>
                      <ContactCard viewMode={true} />
                    </>
                  )}
                </div>
              )}
            </div>
          </FormProvider>
        </Tabs.TabPane>

        <Tabs.TabPane tab="Security" key="2">
          <div>
            <FormProvider {...methods}>
              <div className="p-[32px_36px]">

                <form
                  className="profile_form max-w-full"
                  onSubmit={handleSubmit(submitFormData)}
                >
                  <h2 style={{ borderBottom: "solid 2px #000", marginBottom: "20px", padding: "0px 0px 5px 0px", fontWeight: 500, fontSize: "15px" }}>Change Password</h2>
                  <div className="flex flex-wrap gap-[0_10px]  w-[600px]" ref={pwdPosRef}>
                    <div className="mb-[30px] flex-[1]">
                      <label className="flex justify-between items-center mb-[4px] text-[13px] text-[#798188]">
                        Password
                        {!resPassword && (
                          <span
                            className="text-blue-600 font-medium cursor-pointer"
                            onClick={() => setresPassword(true)}
                          >
                            Set Password
                          </span>
                        )}
                      </label>
                      <Input
                        status={pwdData.pwdError ? "error" : null}
                        value={pwdData.password}
                        onChange={(e) =>
                          setpwdData({ ...pwdData, password: e.target.value })
                        }
                        type="password"
                        placeholder="Enter Password"
                      />
                    </div>
                    {resPassword && (
                      <div className="mb-[30px] w-[210px]">
                        <label className="flex justify-between items-center mb-[4px] text-[13px] text-[#798188]">
                          Confirm Password
                        </label>
                        <Input
                          status={pwdData.cpwdError ? "error" : null}
                          value={pwdData.cnfirm_pwd}
                          onChange={(e) =>
                            setpwdData({ ...pwdData, cnfirm_pwd: e.target.value })
                          }
                          type="password"
                          placeholder="Confirm Password"
                        />
                      </div>
                    )}

                  </div>

                  {/* <div className="flex flex-wrap gap-[0_10px]">
                    <div className="mb-[30px] flex-[1]">

                    </div>
                  </div> */}
                  <h2 style={{ borderBottom: "solid 2px #000", marginTop: "30px", marginBottom: "20px", padding: "0px 0px 5px 0px", fontWeight: 500, fontSize: "15px" }}> Security <span className="text-blue-500 cursor-pointer">ℹ️</span></h2>
                  <div className="rounded bg-white max-w-[300px]">

                    <div className="flex justify-between items-center text-[#4a5568] mb-[10px]">
                      <span>Secret PIN</span>
                      <span>{formatTime()}</span>
                    </div>
                    <div className="text-[28px] font-bold text-[#2d3748] tracking-widest mb-[16px]">{pin}</div>
                    <Button
                      fullWidth
                      variant="contained"
                      disabled={disabled}
                      onClick={handleResendPin}
                      style={{ backgroundColor: disabled ? "#ccc" : "#3182ce", textTransform: 'capitalize' }}
                    >
                      Generate PIN
                    </Button>
                  </div>

                  {/* <div className="flex gap-[10px] mt-4">
                    <Button
                      type="button"
                      className="can_btn"
                      onClick={() => setEditMode(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      className="sav_btn"
                      onClick={() => clickSubmitData("security")}
                    >
                      Save
                    </Button>
                  </div> */}
                </form>
              </div>
            </FormProvider>
          </div>
        </Tabs.TabPane>

      </Tabs>
    </div >


  );
};

export default Profile;
